import {Avatar, Stack, Typography} from "@mui/material";
import {Link} from "react-router-dom";

const UserChip = ({user}) => {
    return (
        <Link target="_blank" to={`https://twitter.com/${user.socials.twitter}`} style={{textDecoration: 'none'}}>
            <Stack direction='row'
                   sx={{
                       m: '0 5px',
                       p: '5px 8px',
                       color: 'text.primary',
                       borderRadius: '5px',
                       backgroundColor: 'rgba(0,0,0,0.4)',
                       alignItems: 'center',
                       justifyContent: 'center'
                   }}>
                <Avatar src={user.image} sx={{height: 32, width: 32}}/>
                <Stack sx={{pl: '8px'}}>
                    <Typography>{user.name}</Typography>
                    <Typography fontSize='0.75rem'>{`@${user.socials.twitter}`}</Typography>
                </Stack>
            </Stack>
        </Link>
    )
}

export default UserChip